import { observable, makeObservable, action } from 'mobx';

import { createReceipt, getReceiptDetail } from '@/api/Payment/receipt';

import ToastUtils from '@/utils/ToastUtils';

// import _ from 'lodash';
class Receipt {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        receiptDetail: {
            id: 2,
            invoice_title: '发票抬头',
            tax_no: '税号',
            work_address: '单位地址',
            work_phone: '单位电话',
            bank_name: '开户银行',
            bank_no: '银行账号',
            user_phone: '手机号',
            email: '邮箱',
            invoice_type: '发票类型',
            title_type: '抬头类型'
        }
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };

    //创建发票
    handleCreateReceipt = async (data) => {
        let res = await createReceipt(data);
        if (res && res.success) {
            return res.data;
        }
        ToastUtils.showAbnormalToast(res.msg || '开票失败');
        return false;
    };

    //查询发票详情
    handleReceiptDetail = async (id) => {
        let data = null;

        let res = await getReceiptDetail(id).catch((err) => console.log(err));
        console.log(res, '哈哈');
        if (res && res.success) {
            data = res.data;
        } else {
            ToastUtils.showAbnormalToast(res?.msg || '查询详情失败');
            data = null;
        }
        this.setState({
            receiptDetail: data
        });
    };
}
export default new Receipt();
